var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Balloon } from "@alife/next";
var Tnc = (function (_super) {
    __extends(Tnc, _super);
    function Tnc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tnc.prototype.render = function () {
        var content = this.props.content;
        var tncContent = Array.isArray(content)
            ? content[0]
            : null;
        return tncContent ? (React.createElement("div", { className: "tnc-content" }, Array.isArray(tncContent.subTC) &&
            tncContent.subTC.map(function (item, index) {
                var _a;
                return (React.createElement("div", { className: "tnc-section" },
                    index !== 0 && React.createElement("hr", null),
                    React.createElement("div", { className: "tnc-section-title" }, item.title),
                    item.content && (React.createElement("div", { className: "tnc-section-content" }, item.content)), (_a = item.subTC) === null || _a === void 0 ? void 0 :
                    _a.map(function (subItem) { return (React.createElement("div", { className: "tnc-sub" },
                        React.createElement("div", { className: "tnc-sub-title" },
                            React.createElement("span", null, subItem.title)),
                        React.createElement("div", { className: "tnc-sub-content" }, subItem.content))); })));
            }))) : null;
    };
    return Tnc;
}(React.Component));
var CardVoucher = (function (_super) {
    __extends(CardVoucher, _super);
    function CardVoucher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardVoucher.prototype.render = function () {
        var _a = this.props, _b = _a.locale, locale = _b === void 0 ? {} : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, templateData = _a.templateData, isSeller = _a.isSeller;
        var _d = templateData.discount, discount = _d === void 0 ? "" : _d, discountUnit = templateData.discountUnit, period = templateData.period, title = templateData.title, newVoucherTag = templateData.newVoucherTag, termsAndConditions = templateData.termsAndConditions;
        return (React.createElement("div", { className: "card-voucher message-card" },
            React.createElement("div", { className: "card-voucher-content" },
                React.createElement("div", { className: "card-voucher-left" },
                    React.createElement("div", { className: "card-voucher-discount" },
                        React.createElement("span", { className: "amount" }, discount.replace(" ", "")),
                        React.createElement("span", { className: "unit" }, discountUnit)),
                    React.createElement("div", { className: "type-name" }, title)),
                React.createElement("div", { className: "card-voucher-right" },
                    React.createElement("div", { className: "card-voucher-title" },
                        React.createElement("div", { className: "title" }, locale.voucherTitle || 'Seller Voucher'),
                        !isSeller && termsAndConditions ? (React.createElement(Balloon, { className: "voucher-tnc-balloon", trigger: React.createElement("div", { className: "tnc" }, "T&C"), triggerType: "hover", closable: false, align: "l" },
                            React.createElement(Tnc, { content: termsAndConditions }))) : null),
                    React.createElement("div", { className: "card-voucher-type" }, newVoucherTag),
                    React.createElement("div", { className: "card-voucher-btn" },
                        React.createElement("div", { className: "period" }, period),
                        React.createElement("div", { className: "btn", onClick: function () { return onClick(templateData); } }, locale.voucherBtn || "Collect"))))));
    };
    return CardVoucher;
}(React.Component));
export default CardVoucher;

//# sourceMappingURL=index.js.map
